/* eslint-disable camelcase */
import { ActionType } from 'typesafe-actions';
import * as actions from './actions';
import { ProductData, ServicesProps } from '../product/types';
import { UserAddresses, UserCard } from '../auth/types';
import { MethodsProps } from '../parameter/types';
import { OrderData, OrderPaymentDetail } from '../order/types';

export type checkoutAction = ActionType<typeof actions>;

/**
 * Action types
 */
export enum checkoutActionTypes {
  GET_CHECKOUT = '@checkout/GET_CHECKOUT',
  UPLOAD_CHECKOUT = '@checkout/UPLOAD_CHECKOUT',
  CHECKOUT_SUCESS = '@checkout/CHECKOUT_SUCESS',
  CHECKOUT_FAILURE = '@checkout/CHECKOUT_FAILURE',
  ADD_PLU_CHECKOUT = '@checkout/ADD_PLU_CHECKOUT',
  UPDATE_PLU_QTY_CHECKOUT = '@checkout/UPDATE_PLU_QTY_CHECKOUT',
  REMOVE_PLU_CHECKOUT = '@checkout/REMOVE_PLU_CHECKOUT',
  CLOSE_SALE = '@checkout/CLOSE_SALE',
  CLOSE_SALE_SUCCESS = '@checkout/CLOSE_SALE_SUCCESS',
  CLOSE_SALE_FAILURE = '@checkout/CLOSE_SALE_FAILURE',
  CLEAR_SALE = '@checkout/CLEAR_SALE',
  VOIDED_SALE = '@checkout/VOIDED_SALE',
  VOIDED_SALE_SUCCESS = '@checkout/VOIDED_SALE_SUCCESS',
  VOIDED_SALE_FAILURE = '@checkout/VOIDED_SALE_FAILURE',
  ORDER_ID_REMAKE_REQUEST = '@checkout/ORDER_ID_REMAKE_REQUEST',
  ORDER_ID_REMAKE_SUCCESS = '@checkout/ORDER_ID_REMAKE_SUCCESS',
  CLEAR_ERROR = '@checkout/CLEAR_ERROR',
  SEND_REQUEST_NEW = '@checkout/SEND_REQUEST_NEW',
  SEND_REQUEST_NEW_SUCCESS = '@checkout/SEND_REQUEST_NEW_SUCCESS',
  SET_SHIPPING_PRICE = '@checkout/SET_SHIPPING_PRICE',
  SET_SERVICES = '@checkout/SET_SERVICES',
  DELET_SERVICES = '@checkout/DELET_SERVICES',
  CHANGE_SERVICES = '@checkut/CHANGE_SERVICES',
  VERIFY_CUSTOMER_CARD_IS_EXIST = '@checkout/VERIFY_CUSTOMER_CARD_IS_EXIST',
  VERIFY_CUSTOMER_CARD_IS_EXIST_SUCESS = '@checkout/VERIFY_CUSTOMER_CARD_IS_EXIST_SUCESS',
  UPDATE_CUSTOMER_CARD = '@checkout/UPDATE_CUSTOMER_CARD',
  LOGOUT_CUSTOMER_CARD = '@checkout/LOGOUT_CUSTOMER_CARD',
  CREATE_OR_UPDATE_CUSTOMER_CARD = '@checkout/CREATE_OR_UPDATE_CUSTOMER_CARD',
  CREATE_OR_UPDATE_CUSTOMER_CARD_SUCESS = '@checkout/CREATE_OR_UPDATE_CUSTOMER_CARD_SUCESS',
  SELECT_ADDRESS_CUSTOMER_CARD = '@checkout/SELECT_ADDRESS_CUSTOMER_CARD',
  REMOVE_ADDRESS_CUSTOMER_CARD = '@checkout/REMOVE_ADDRESS_CUSTOMER_CARD',
  REMOVE_ADDRESS_CUSTOMER_CARD_SUCESS = '@checkout/REMOVE_ADDRESS_CUSTOMER_CARD_SUCESS',
  CLEAR_MESSAGE_CUSTOMER_CARD = '@checkout/CLEAR_MESSAGE_CUSTOMER_CARD',
  CLEAR_LOADING = '@checkout/CLEAR_LOADING',
  APPLY_COUPON = '@checkout/APPLY_COUPON',
  METHOD_PAYMENT_SELECTED = '@checkout/METHOD_PAYMENT_SELECTED',
  CHECK_PAYMENT_REQUEST = '@checkout/CHECK_PAYMENT_REQUEST',
  CHECK_PAYMENT_RESPONSE = '@checkout/CHECK_PAYMENT_RESPONSE',
  ORDER_CHECKOUT_RESPONSE = '@checkout/ORDER_CHECKOUT_RESPONSE',
  ORDER_CHECKOUT_CLEAR = '@checkout/ORDER_CHECKOUT_CLEAR',
}

export interface orderDataSuccess {
  order_id?: string;
  cart_id?: string;
  sub_total?: string;
}

export interface checkoutProductProps {
  productId?: string;
  name?: string;
  price?: number;
  quantity?: number;
  imageURL?: string;
  categoryName?: string;
  send?: boolean;
}

export interface ServicesCheckoutProps {
  product_id: string;
  service: ServicesProps;
}

export interface CustomerCheckoutProps {
  customer: {
    first_name: string;
    last_name: string;
    email: string;

    cpf_cnpj?: string;
    birth?: string;
    date_of_birth?: string;
    phone_mobile?: string;

    customer_id: string;
    gender: string;
    phone: string;
    conf_code?: string;
    id: string;
    token: string;
    address: UserAddresses[];
  };
}

export interface CustomerProps {
  message: string;
  data: CustomerCheckoutProps;
}

export type CheckoutItemEspecificationProps = Omit<
  ProductData,
  | 'min_qty'
  | 'max_qty'
  | 'info_to_customer'
  | 'stars'
  | 'discount_amount'
  | 'quantity'
  | 'quantityAfter'
  | 'cart_item_id'
  | 'order_item_id'
  | 'product'
  | 'qty_ordered'
  | 'grant_total'
>;

export interface CheckoutItemsProps {
  cart_item_id: number;
  quantity: string;
  id: string;
  sku: string;
  short_description: string;
  price: string;
  total: string;
  product: CheckoutItemEspecificationProps;
  is_available: number;
  additional: {
    observation?: string;
  },
}

export interface checkoutDataResponseApi {
  id: number;
  items_count: number;
  coupon_code?: string;
  grand_total: string;
  sub_total: string;
  services?: ServicesCheckoutProps[];
  items: CheckoutItemsProps[];
  discount: string;
  shipping?: number;
  customer?: CustomerProps;
}

export interface checkoutData {
  id: number;
  items_count: number;
  coupon_code?: string;
  grand_total: string;
  sub_total: string;
  services?: ServicesCheckoutProps[];
  items: Record<string, CheckoutItemsProps>;
  discount: string;
  shipping?: number;
  customer?: CustomerProps;
}

export interface checkoutDataSuccess {
  id?: string;
  grand_total?: string;
  sub_total?: string;
  items?: ProductData[];
  order_save?: boolean;
  loading?: boolean;
}

export interface errorData {
  code: string;
  message: string;
  data: string;
}

export interface cartProductProps {
  product_id: string;
  quantity: string;
  sellerId?: number;
  serviceId?: number;
  observation?: string;
}

export interface IMethodPaymentSelected {
  cards: Array<UserCard>;
  others: Array<MethodsProps>;
  cashOnDelivery: Array<MethodsProps>;
}

export interface IOrderCheckout {
    order: OrderData;
    payment_detail: OrderPaymentDetail;
  }


export interface checkoutState {
  readonly checkout: checkoutData;
  readonly shipping: number;
  readonly loading: boolean;
  readonly error: boolean;
  readonly errorData?: errorData;
  readonly order?: orderDataSuccess;
  readonly methodPaymentSelected: IMethodPaymentSelected;
  readonly orderCheckout: IOrderCheckout;
}
